import { render } from "./DeliveredLocation.vue?vue&type=template&id=b118ecf2"
import script from "./DeliveredLocation.vue?vue&type=script&lang=js"
export * from "./DeliveredLocation.vue?vue&type=script&lang=js"

import "./DeliveredLocation.vue?vue&type=style&index=0&id=b118ecf2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__